export enum StoryBlokVersion {
    Draft = 'draft',
    Published = 'published',
}
